import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill-new';
import 'react-quill/dist/quill.snow.css';

const EditReviewModal = ({ show, handleClose, review, onSave }) => {
  const [content, setContent] = useState('');
  const [status, setStatus] = useState('approved'); // approved or rejected
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (review) {
      setContent(review.review || '');
      setStatus(review.status || 'approved');
      setName(review.name || '');
      setError('');
    }
  }, [review]);

  const handleSubmit = () => {
    if (!content || content.replace(/<[^>]*>?/gm, '').trim() === '') {
      setError('Review content is required');
      return;
    }

    const updatedReview = {
      ...review,
      content,
      status,
      name,
    };

    onSave(updatedReview);
    setError('');
  };

  const closeAndReset = () => {
    setContent('');
    setStatus('approved');
    setName('');
    setError('');
    handleClose();
  };

  return (
    <Modal show={show} onHide={closeAndReset} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Review</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Form.Group className="mb-3">
          <Form.Label style={{ textAlign: 'left', display: 'block', fontWeight: '500' }}>Reviewer Name</Form.Label>
          <Form.Control
            type="text"
            value={name}
            disabled={true}
            onChange={(e) => setName(e.target.value)}
            placeholder="Reviewer Name"
            className='px-2'
          />
        </Form.Group> */}

        <Form.Group className="mb-3">
          <Form.Label style={{ textAlign: 'left', display: 'block', fontWeight: '500' }}>
            Review Content <span className="text-danger">*</span>
          </Form.Label>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            
          />
          {error && <div className="invalid-feedback d-block mt-1">{error}</div>}
        </Form.Group>

        <Form.Group className="mb-3" style={{marginTop:'20px'}}>
          <Form.Label style={{ textAlign: 'left', display: 'block', fontWeight: '500' }}>Status  <span className="text-danger">*</span></Form.Label>
          <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} className='form-control'>
            <option value="published">Published</option>
            <option value="unpublished">Unpublished</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeAndReset}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditReviewModal;
